import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { DamageCostEvaluationDto, EntityType } from "@/core/api/generated/v1";

interface Props {
  damageCostEvaluation: DamageCostEvaluationDto;
}

export default function CommentsTabContent({ damageCostEvaluation }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={2}>
        <EntityCommentsChat
          entityId={damageCostEvaluation.id!}
          entityType={EntityType.DamageCostEvaluation}
          entity={damageCostEvaluation}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
